import { actionTypes } from 'redux-form/lib/immutable';
import { call, put, takeEvery } from 'redux-saga/effects';

import { createActionPatternForForm, getFormChangeDetails } from '../utils/reduxFormUtils';
import { fieldChanged, formInitialized, formReset } from './paymentFormModule';
import { PAYMENT_FORM_NAME } from './paymentConstants';

const paymentFormActionPattern = createActionPatternForForm(PAYMENT_FORM_NAME);

export function* paymentFormActionWatcher() {
    
    yield takeEvery(paymentFormActionPattern(actionTypes.CHANGE), function* handleFormChange(action) {
        const changeDetails = yield call(getFormChangeDetails, action);
        yield put(fieldChanged(changeDetails.field, changeDetails.value));
    });

    
    yield takeEvery(paymentFormActionPattern(actionTypes.INITIALIZE), function* handleFormInitialize() {
        yield put(formInitialized());
    });

    
    yield takeEvery(paymentFormActionPattern(actionTypes.RESET), function* handleFormReset() {
        yield put(formReset());
    });
}
